const translations = {
  "en": {
    "20-day avg": "20-day avg",
    "average volume": "average volume",
    "Current": "Current"
  },
  "zh-tw": {
    "20-day avg": "20 日均值",
    "average volume": "平均成交量",
    "Current": "目前"
  }
};

export default translations;
